

import Vue from "vue";
import msDataProvider from "@/services/msDataProvider";
import {addAction} from "@/services/firebase/writeData";
import uiService from "@/services/uiService";

export default Vue.extend({
  props: ["updateStatus"],
  data() {
    return {
      newVersion: "",
      isCheckingUpdate: false,
      isLatestVersion: false,
      binding: {},
      changelog: []
    }
  },
  async created() {
    await msDataProvider.bindDataMany(
        [
          "updateApplied",
        ],
        this.binding,
        this,
        (key, data) => {
          if (key === "updateApplied" && typeof data === "boolean") {
            if (data) {
              this.isCheckingUpdate = false;
              this.isLatestVersion = false;
              this.newVersion = "";
            } else {
              this.checkUpdate()
            }
          }
        },
        this
    );
  },
  methods: {
    async checkUpdate() {
      this.isCheckingUpdate = true;
      const data = await msDataProvider.executeCommand(
          "updateFetchAvailableVersionsInfo"
      );
      this.isCheckingUpdate = false;
      if (!data || !data.latest_version) {
        this.isLatestVersion = true;
      } else {
        this.isLatestVersion = false;
        this.newVersion = data.latest_version;
        if (data.update_versions && Array.isArray(data.update_versions) && data.update_versions.length > 0 && data.update_versions[data.update_versions.length - 1].changelog) {
          this.changelog = data.update_versions[data.update_versions.length - 1].changelog.split("+");
        }
      }
      await addAction('click_to_check_update')
    },

    async updateVersion() {
      await uiService.executeCommand("try", {
        async func() {
          await msDataProvider.executeCommand("updateDownloadAndApply", {});
        },
        self: this,
      });
    }
  }
})
